/**
 * Coordinate conversion utilities
 *
 * Converts GPS coordinates from NMEA format (DDDMM.MMMM) to decimal degrees.
 * NMEA format stores degrees and decimal minutes together, so we need to
 * extract the degrees and convert the minutes to decimal degrees.
 */

/**
 * Convert a single coordinate value from NMEA format to decimal degrees
 *
 * @param {number} nmeaValue - Coordinate in NMEA format (DDDMM.MMMM * 100)
 * @returns {number} Coordinate in decimal degrees
 *
 * @example
 * // 5920.1234 NMEA = 59 degrees 20.1234 minutes
 * convertNmeaToDecimal(592012.34) // returns ~59.33539
 */
export function convertNmeaToDecimal(nmeaValue) {
  var scaled = nmeaValue / 100
  var degrees = Math.trunc(scaled)
  var minutes = scaled - degrees
  return degrees + (minutes / 0.6)
}

/**
 * Convert latitude and longitude from NMEA format to [lon, lat] array
 * suitable for OpenLayers/VueLayers map coordinates
 *
 * @param {Object} coords - Object with latitude and longitude properties
 * @param {number} coords.latitude - Latitude in NMEA format
 * @param {number} coords.longitude - Longitude in NMEA format
 * @returns {number[]} Array of [longitude, latitude] in decimal degrees
 *
 * @example
 * convertCoordinates({ latitude: 592012.34, longitude: 180345.67 })
 * // returns [18.05761..., 59.33539...]
 */
export function convertCoordinates(coords) {
  return [
    convertNmeaToDecimal(coords.longitude),
    convertNmeaToDecimal(coords.latitude)
  ]
}



// WEBPACK FOOTER //
// ./src/utils/coordinates.js